import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage, pick } from "@/lib/lang";
import { t } from "@/lib/content";
import PeonyMark from "@/components/ui-brand/PeonyMark";

const NotFoundPage = () => {
  const { lang } = useLanguage();

  useEffect(() => {
    document.title = lang === "de"
      ? "Dieser Raum existiert nicht (noch nicht) · patrice.studio"
      : "This room doesn't exist (yet) · patrice.studio";
  }, [lang]);

  return (
    <section className="relative px-6 md:px-12 lg:px-24 pt-12 md:pt-16 pb-24 min-h-[80vh] flex items-center overflow-hidden">
      <PeonyMark size={680} opacity={0.05} className="absolute -right-40 -top-32 pointer-events-none" />
      <PeonyMark size={420} opacity={0.04} className="absolute -left-24 bottom-10 pointer-events-none" />

      <div className="grid grid-cols-12 gap-6 lg:gap-12 w-full">
        <div className="col-span-12 lg:col-span-7 lg:col-start-2">
          <p className="font-mono text-[0.62rem] tracking-[0.32em] uppercase text-atmosphere">
            404 — A quiet detour
          </p>
          <h1 className="font-display text-[clamp(2.6rem,6.5vw,5.6rem)] leading-[0.96] mt-8 tracking-tight">
            <span className="italic-serif text-atmosphere">Dieser Raum</span>
            <br />
            existiert nicht{" "}
            <span className="font-light text-warmth">(noch nicht).</span>
          </h1>
          <p className="body-lux mt-10 max-w-xl">
            {lang === "de"
              ? "Vielleicht ist die Seite umgezogen. Vielleicht wartet sie noch im Atelier. Vielleicht hast du dich verlaufen — was im Übrigen erlaubt ist. Manche der schönsten Orte entstehen aus einem Umweg."
              : "Maybe this page has moved. Maybe it's still being arranged in the studio. Maybe you took a wrong turn — which is allowed. Some of the most beautiful places come from a detour."}
          </p>
          <div className="mt-14 flex flex-wrap gap-6 items-center">
            <Link
              to="/"
              data-testid="notfound-home"
              className="inline-flex items-center gap-3 px-8 py-4 bg-depth text-canvas font-mono text-[0.65rem] tracking-[0.32em] uppercase hover:bg-signal transition-colors"
            >
              {lang === "de" ? "Zurück nach Hause" : "Back home"} <span aria-hidden>↗</span>
            </Link>
            <Link
              to="/projekte"
              data-testid="notfound-projects"
              className="font-mono text-[0.62rem] tracking-[0.32em] uppercase text-depth hover:text-signal transition-colors"
            >
              {lang === "de" ? "Oder ins Projekt-Universum" : "Or to the project universe"} ↗
            </Link>
          </div>
          <p className="mt-16 font-display italic text-atmosphere/80 text-lg max-w-md">
            {lang === "de"
              ? "„Ein Umweg ist nur ein Weg, den man noch nicht kannte."
              : "„A detour is just a path you didn't know yet."}
          </p>
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
